import { render, staticRenderFns } from "./StatementAddOrRemoveAni.vue?vue&type=template&id=74e656e6&"
import script from "./StatementAddOrRemoveAni.vue?vue&type=script&lang=js&"
export * from "./StatementAddOrRemoveAni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports